(ns guidebook.views.performance
  (:require
    [very.re-frame.core :as rf]
    [reagent.core :as r]
    [css.core :refer [defstyled]]
    [css.vars :as vars]
    [cljss.core :as cljss]
    [main.common :as common]
    [guidebook.common :as gc]
    [reagent.format :as fmt]))

(defstyled performance-s :div
  {:padding "133px 100px"
   ::cljss/media {[:print]
                  {:padding "80px 60px 160px"}}})

(defstyled summary-s :div
  {:display "grid"
   :grid-auto-columns "max-content"
   :grid-auto-flow "column"
   :align-items "center"
   :grid-gap "6rem"
   :margin "6rem 0"
   :padding "1.5rem 1rem"
   :border-top (str "1px solid " vars/border-light)
   :border-bottom (str "1px solid " vars/border-light)
   ::cljss/media {[:print]
                  {:margin "3rem 0"}}})

(defstyled summary-item-s :div
  {:font-size "22px"
   :text-transform "uppercase"
   ::cljss/media {[:print]
                  {:font-size "18px"}}})

(defstyled summary-value-s :span
  {:padding-left ".75rem"
   :color vars/gray})

(defstyled summary-label-s :span
  {:padding-left ".75rem"
   :color vars/gray})

(defstyled table-header-s :h2
  {:font-size "32px"
   :padding-bottom "1rem"
   :padding-left "1rem"
   :border-bottom (str "1px solid " vars/border-light)
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :font-weight "400"
                   :font-size "28px"}}})

(defstyled table-s :table
  {:width "100%"
   :border-spacing "0"})

(defstyled th-s :th
  {:text-align "left"
   :padding "1.25rem 1.5rem 1.25rem 0"
   :text-transform "uppercase"
   :font-size "18px"
   :font-weight "700"
   :&:first-child {:padding-left "1rem"}
   ::cljss/media {[:print]
                  {:font-size "14px"}}})

(defstyled tr-s :tr
  {"&:nth-child(odd)" {:background "rgba(0, 0, 0, 0.05)"}})

(defstyled td-s :td
  {:padding "1.25rem 1.5rem 1.25rem 0"
   :font-size (with-meta #(if % "28px" "22px") :total?)
   :font-weight (with-meta #(if % "700" "400") :total?)
   :color (with-meta identity :color)
   :&:first-child {:padding-left "1rem"}
   ::cljss/media {[:print]
                  {:font-size (with-meta #(if % "22px" "16px") :total?)}}})

(defn- pct-fmt [x]
  (str (fmt/format "%.2f" (or x 0)) "%"))

(defn- summary [total return return-window]
  [summary-s
   [summary-item-s
    [common/bold-s "Total:"]
    [summary-value-s (fmt/currency-format total)]]
   [summary-item-s
    [common/bold-s "Time Weighted Return:"]
    [summary-value-s {:data-test "guidebook-time-weighted-return"} (pct-fmt return) ()]
    [summary-label-s return-window]]])

(def table-columns #{{:order 0
                      :label "Name"
                      :key [:name]}
                     {:order 1
                      :label "Type"
                      :key [:type]}
                     {:order 2
                      :label "Custodian"
                      :key [:custodian]}
                     {:order 3
                      :label "Strategy"
                      :key [:strategy]}
                     {:order 4
                      :label "Market Value"
                      :key [:market-value]
                      :fmt (fn [x] (fmt/currency-format x))}
                     {:order 5
                      :label "Performance"
                      :key [:performance :year-td]
                      :fmt (fn [x] (str
                                     (if (> x 0) "+" "")
                                     (pct-fmt x)))}
                     {:order 6
                      :label "Allocation"
                      :key [:percent]
                      :fmt (fn [x] (str x "%"))}})

(defn main []
  (let [perf (rf/subscribe [:guidebook/performance])
        accs (rf/subscribe [:guidebook/non-zero-accounts])
        alloc (rf/subscribe [:guidebook/total-account-allocation])]
    (fn []
      [performance-s
       [gc/title-s "Performance"]
       [summary
        (get-in @perf [:internal :total-value])
        (get-in @perf [:avg-performance :year-td])
        "(YTD)"]
       [table-header-s "Accounts"]
       [table-s
        [:thead
         (into [:tr]
               (for [r (sort-by :order table-columns)]
                 [th-s (:label r)]))]
        [:tbody
         (for [r @accs]
           (into [tr-s {:key (:id r)
                        :data-test "guidebook-performance-account"}]
                 (mapv #(vector
                          td-s
                          ((get % :fmt identity)
                           (get-in r (get % :key))))
                       (sort-by :order table-columns))))
         [tr-s
          [td-s {"colSpan" "4" :total? true} "TOTAL"]
          [td-s {"colSpan" "2" :total? true :data-test "guidebook-performance-market-value-total"}
           (fmt/currency-format (get-in @perf [:internal :total-value]))]
          ;; per business rules, this should always show 100% and they don't
          ;; care about rounding errors: Quin Kilgore 8/16/2018
          [td-s {:total? true} "100%"]]]]])))



